<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" justify="space-between" align="middle">
        <el-col :span="12">
          <el-page-header @back="onBack" title="" content="設定 - 回報問題類別">
          </el-page-header>
        </el-col>
        <el-col :span="4" style="text-align: right;">
          <el-button type="info" @click="onAdd">新增回報問題類別</el-button>
        </el-col>
      </el-row>
      <div class="page-box">
        <el-table
          @sort-change="handleSortChange"
          :data="tableData"
          style="width: 100%;"
        >
          <el-table-column label="#" prop="position" align="center">
          </el-table-column>
          <el-table-column
            prop="name"
            label="類別"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="{ row }">
              <el-button type="text" size="medium" @click="onDelete(row.id)"
                >删除</el-button
              >
              <el-button
                type="text"
                size="medium"
                @click="onEdit(row, row.id)"
                >編輯</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <dialogSlotVisible :centerDialogVisible="centerDialogVisible">
      <div>{{ title }}</div>
      <el-form  :model="formInline" class="demo-form-inline">
          <el-form-item label="標題">
           <el-input v-model="formInline.input" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="次序">
           <el-input v-model.number="formInline.position" placeholder=""></el-input>
          </el-form-item>
    </el-form>
      <div class="page-button">
        <el-button type="info" @click="onConfirm">確定</el-button>
        <el-button type="success" @click="onCancel">取消</el-button>
      </div>
    </dialogSlotVisible>
  </div>
</template>

<script>
import dialogSlotVisible from "@/components/dialogSlotVisible";
import {
  getQuestionFeedbackCategories,
  addQuestionFeedbackCategories,
  editQuestionFeedbackCategories,
  getQuestionFeedbackCategoriesDetail,
  deleteQuestionFeedbackCategories,
} from "@/api/setting";
export default {
  components: {
    dialogSlotVisible,
  },
  data() {
    return {
      formInline:{
        input: null,
        position: null,
      },
      itemId: null,
      title: null,
      questionFeedbackCategoriesDetail:{},
      centerDialogVisible: false,
      tableData: [],
      tableLabels: [
        {
          label: "年級名稱",
          prop: "gradeName",
        },
        {
          label: "購課用戶數量",
          prop: "buyNum",
        },
        {
          label: "發佈時間",
          prop: "createdAt",
        },
        {
          label: "銷售合計總價",
          prop: "totalPrice",
        },
      ],
      from: {
        orderBy: null,
      },
    };
  },
  created() {
    this.getQuestionFeedbackCategories();
  },
  methods: {
    onDelete(id) {
      this.itemId = id;
      this.$confirm("此操作將刪除該回報問題類別, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
          this.deleteQuestionFeedbackCategories();
      })
      .catch(() => {
          this.$message({
            type: "info",
            message: "已取消刪除",
          });
      });
    },
    onConfirm() {
      if (this.itemId != null) {
        this.editQuestionFeedbackCategories();
      } else {
        this.addQuestionFeedbackCategories();
      }
    },
    onCancel() {
      this.centerDialogVisible = false;
    },
    onEdit(row, id) {
      this.title = '編輯'
      this.formInline.input = row.name;
      this.formInline.position = row.position;
      this.itemId = id;
      this.centerDialogVisible = true;
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.from.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.from.orderBy = column.prop + " asc";
      } else {
        this.from.orderBy = null;
      }
      this.getQuestionFeedbackCategories();
    },
    onAdd() {
      this.title = '新增'
      this.formInline.position = null
      this.formInline.input = null
      this.itemId = null
      this.centerDialogVisible = true;
    },
    onSearch() {
      this.getQuestionFeedbackCategories();
    },
    //获取问题反馈详情
    getQuestionFeedbackCategoriesDetail() {
      getQuestionFeedbackCategoriesDetail(this.itemId).then((res) => {
        this.questionFeedbackCategoriesDetail = res.data;
      });
    },

    //編輯
    editQuestionFeedbackCategories() {
      let from = {
        name: this.formInline.input,
        position: this.formInline.position,
      };
      editQuestionFeedbackCategories(this.itemId, from)
        .then(() => {
          this.getQuestionFeedbackCategories();
        })
        .finally(() => {
          this.centerDialogVisible = false;
        });
    },
    addQuestionFeedbackCategories() {
      let from = {
        name: this.formInline.input,
        position: this.formInline.position,
      };
      addQuestionFeedbackCategories(from)
        .then(() => {
          this.getQuestionFeedbackCategories();
        })
        .finally(() => {
          this.centerDialogVisible = false;
        });
    },

    deleteQuestionFeedbackCategories() {
      deleteQuestionFeedbackCategories(this.itemId).then(() => {
        this.getQuestionFeedbackCategories();
      });
    },
    // 获取问题反馈列表
    getQuestionFeedbackCategories() {
      let from = {
        orderBy: this.from.orderBy,
      };
      getQuestionFeedbackCategories(from).then((v) => {
        this.tableData = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      padding-left: 20px;
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
}
.page-box {
  background-color: #fff;
  margin-top: 20px;
}
</style>